export const API_URL = process.env.REACT_APP_API_URL as string;
export const CRIPTO_SECRETKEY = process.env.REACT_APP_CRIPTO_SECRETKEY as string;
export const COMMBITZ_URL = process.env.REACT_APP_COMMBITZ_URL
 //export const STRIPE_PUBLIC_KEY = `${process.env.REACT_APP_STRIPE_PUBLIC_KEY}` as string;